var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDeleteIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.53 6.53a.751.751 0 0 0-1.062-1.062L8 7.938 5.53 5.47a.751.751 0 0 0-1.062 1.062L6.938 9 4.47 11.47a.751.751 0 0 0 1.062 1.062L8 10.062l2.47 2.468a.751.751 0 0 0 1.062-1.062L9.062 9l2.468-2.47Z"
})));
export default SvgDeleteIcon;